export default __webpack_public_path__ + "static/media/G0007.ff95300a.png";